import React from 'react';
import { WebpageContent } from '../elements/WebpageContent';
import { TextContent } from '../elements/TextContent';
import { LinkContent } from '../elements/LinkContent';
import { TypeAnimation } from 'react-type-animation';

export const Landing = () => {
  return (
    <WebpageContent>
      <>
        <>
          {/* <LinkContent label={'Home'} href={'/'} tailwindCss={'text-xs lg:text-base font-extra-thin'} /> */}
          {/* <LinkContent label={'Resume'} href={'/resume'} tailwindCss={'text-xs lg:text-base font-extra-thin'} /> */}
          <LinkContent
            label={'LinkedIn'}
            href={'https://www.linkedin.com/in/harshad12patre'}
            isExternal={true}
            tailwindCss={'text-xs lg:text-base font-extra-thin'}
          />
        </>
        <br />
        <TextContent
          label={
            <TypeAnimation
              sequence={['Harsg', 250, 'Harshad Barapatre']}
              wrapper="div"
              speed={{
                type: 'keyStrokeDelayInMs',
                value: 200,
              }}
              style={{
                display: 'inline-block',
              }}
              repeat={0}
            />
          }
          tailwindCss={'text-2xl lg:text-5xl font-normal'}
        />
      </>
    </WebpageContent>
  );
};
